import {useState, useEffect} from 'react';
import './subscriptionPackage.scss';
import axios from 'axios';
import {toast, ToastContainer} from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import {Button, Progress} from 'rsuite';
import {Radio, RadioGroup, Form} from 'rsuite';
import {Loader, Placeholder} from 'rsuite';
import TargetIcon from '../../img/target.svg';
import CalendarIcon from '../../img/calendar.svg';
import VoucherIcon from "../../img/voucher_icon.svg";
import CloseIcon from "../../img/close_red.svg";
import CheckRoundIcon from '@rsuite/icons/CheckRound';
import AuthService from "../../services/auth.service";
import {Navigate, redirect, useNavigate} from "react-router-dom";
import campaignService from "../../services/campaign.service";
import CampaignService from "../../services/campaign.service";
import TicIcon from './../../../src/img/tick-square.svg'
import MinCloseIcon from '@rsuite/icons/Close';

const APP_URL = process.env.APP_URL;

const SubscriptionPackage = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [isCheckingVoucher, setIsCheckingVoucher] = useState(false);
    const [formData, setFormData] = useState(null);
    const [helps, setHelps] = useState(null);
    const [selectedSubscriptionPackage, setSelectedSubscriptionPackage] = useState(null);
    const [code, setCode] = useState("");
    const [isActive, setIsActive] = useState(false);
    const [isActiveText, setIsActiveText] = useState("کد تخفیف دارید؟");
    const [messageClass, setMessageClass] = useState("");
    const [messageType, setMessageType] = useState("");
    const [message, setMessage] = useState("");
    const [buttonStatus, setButtonStatus] = useState(true);
    const [buttonContent, setButtonContent] = useState("");
    const [subscriptionPackageFinalPrice, setSubscriptionPackageFinalPrice] = useState(null);
    const [subscriptionPackageFinalPriceText, setSubscriptionPackageFinalPriceText] = useState(null);
    const [trialDays, setTrialDays] = useState(null);
    const [shadow, setShadow] = useState(null);
    const [voucherAccept, setVoucherAccept] = useState(false);

    const navigate = useNavigate();

    if ((AuthService && AuthService.getSubscription() && !AuthService.getSubscription()?.is_expired && !AuthService.getSubscription().trial_expired_at && AuthService.getUser().subscription.days > 2) || AuthService.getUser().reserved ) {
        window.location.href = '/subscriptions';
    }

    let searchParams = new URLSearchParams(document.location.search)
    if (searchParams.get('voucherCode') != null && searchParams.get('voucherCode').length > 0 && isActive === false) {
        setIsActive(true);
        setCode(searchParams.get('voucherCode'))
    }

    useEffect(() => {
        getFormData();
    }, []);

    const validate = () => {
        return code.length;
    };

    const activeCodeGroup = event => {
        setIsActive(!isActive);
        setIsActiveText("کد تخفیف");
    };

    const removeCode = () => {
        // 👇️ toggle isActive state on click
        setButtonStatus(true);
        setMessageClass("");
        setMessage("");
        setCode("");
        setMessageType("");
        setVoucherAccept(false)
        handleOnChangeSubscriptionPackage(selectedSubscriptionPackage, false);
    };

    const resetInput = () => {
        setButtonStatus(true);
        setMessageClass("");
        setMessage("");
        setMessageType("");
        handleOnChangeSubscriptionPackage(selectedSubscriptionPackage, false);
    };


    return (
        <div className="container subscription-package-route">
            <div className="form-container">
                <div className="center">
                    {
                        formData ? render() : <>
                            <Placeholder.Paragraph rows={8}/>
                            <Loader
                                backdrop
                                content="درحال بارگذاری ..."
                                vertical/>
                        </>
                    }
                </div>
            </div>

            <ToastContainer
                position="top-center"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
        </div>
    );

    function getSubscriptionPackageByIndex(subscriptionPackageIndex) {

    }

    function handleOnChangeSubscriptionPackage(subscriptionPackage, hasVoucher = true) {
        setSubscriptionPackageFinalPrice(subscriptionPackage.final_price);
        setSubscriptionPackageFinalPriceText(subscriptionPackage.final_price_text);
        setSelectedSubscriptionPackage(subscriptionPackage);
        setTrialDays(null);

        if (hasVoucher) {
            applyVoucher(subscriptionPackage);
        }
        setShadow(subscriptionPackage.id);
    }

    function render() {
        let submitButtonText = subscriptionPackageFinalPrice == 0 ? 'دریافت رایگان اشتراک' : 'پرداخت';

        if (trialDays && trialDays > 0) {
            submitButtonText = `دریافت رایگان اشتراک ${trialDays} روزه`;
        }

        return (<>
            <Form>
                <div className="form-header">
                    <div className="close-page" onClick={e => navigate('/')}>
                        <MinCloseIcon/>
                    </div>
                    <div className="form-title">انتخاب برنامه</div>
                    <div className="subscription-package-target">

                        {/*<div className="target-title">*/}
                        {/*    <div className="icon"><img src={TargetIcon}/></div>*/}
                        {/*    <div className="content-container">*/}
                        {/*        <div className="title">هدف:</div>*/}
                        {/*        <div*/}
                        {/*            className="content">{selectedSubscriptionPackage ? selectedSubscriptionPackage.target_title : '...'}</div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        {/*<div className="divider"></div>*/}
                        {/*<div className="target-duration">*/}
                        {/*    <div className="icon"><img src={CalendarIcon}/></div>*/}
                        {/*    <div className="content-container">*/}
                        {/*        <div className="title">مدت زمان:</div>*/}
                        {/*        <div*/}
                        {/*            className="content">{selectedSubscriptionPackage ? `${selectedSubscriptionPackage.days / 30} ماه` : '...'}</div>*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                    </div>
                </div>
                <RadioGroup
                    name="subscription-package"
                    value={selectedSubscriptionPackage ? selectedSubscriptionPackage.id : null}>
                    {formData.map((subscriptionPackage, subscriptionPackageIndex) => {

                        return <Radio
                            className={`d-block subscription-package-item   shadow-normal ${shadow == subscriptionPackage.id ? 'new-box-shadow' : 'shadow'}`}
                            appearance="default"
                            style={{marginLeft: 0}}
                            value={subscriptionPackage.id}
                            onChange={(e) => handleOnChangeSubscriptionPackage(subscriptionPackage)}
                            key={subscriptionPackageIndex}>

                            <div className="option-title">{subscriptionPackage.title}</div>
                            <div className="option-content">{subscriptionPackage.target_title}</div>

                            <div className="option-pricing">
                                <div className="off-percentage">
                                    {subscriptionPackage.off_price ? (
                                            <>
                                                <div className="percentage">
                                                    {priceFormat(100 - ((subscriptionPackage.off_price * 100) / subscriptionPackage.price))}%
                                                </div>
                                                <div className="label">تخفیف</div>
                                            </>
                                        )
                                        : (<>
                                            <div className="no-off-label">
                                                بدون
                                                <br/>
                                                تخفیف
                                            </div>
                                        </>)}
                                </div>
                                <div className="prices">
                                    <div
                                        className="final-price">{subscriptionPackage.off_price ? priceFormat(subscriptionPackage.off_price) : priceFormat(subscriptionPackage.price)} تومان
                                    </div>
                                    {subscriptionPackage.off_price ? <div
                                        className="real-price">{priceFormat(subscriptionPackage.price)} تومان</div> : ''}
                                </div>
                            </div>
                        </Radio>;
                    })}
                </RadioGroup>
                <div className="voucher-div">
                    <div className="voucher">
                        <div className="section-group shadow-normal">
                            <div className="overlap">
                                <div className="question-group">
                                    <img className="vector" alt="Vector" src={VoucherIcon}/>
                                    <div className="voucher-text">{isActiveText}</div>
                                </div>
                                <button className={isActive ? 'enter-code-disabled' : 'enter-code'}
                                        onClick={activeCodeGroup}>
                                    وارد کردن کد
                                </button>
                            </div>
                            <div
                                className={`code-group ${isCheckingVoucher ? 'has-loader' : ''}` + ' ' + (isActive ? 'expanded ' : 'collapsed ') + (messageType)}>
                                <input type="text" className={`${voucherAccept ? 'voucher-code' : ''}`}
                                       placeholder="کد تخفیف را اینجا وارد کنید" name="code" value={code}
                                       onChange={(e) => setCode(e.target.value)} onKeyUp={resetInput}/>

                                {
                                    buttonStatus || isCheckingVoucher ? (
                                        <button className={validate() ? 'submit' : ''} disabled={!validate()}
                                                onClick={e => applyVoucher(selectedSubscriptionPackage)}>
                                            <span className="button-text">ثبت</span>
                                            <Loader className="voucher-loader" speed="fast"/>
                                        </button>) : (<button className={`delete ${voucherAccept ? 'delete-text' : ''}`}
                                                              onClick={removeCode}>
                                        {(buttonContent === "حذف") ? "حذف" : (
                                            <img className="closeIcon" alt="CloseIcon" src={CloseIcon}/>)}
                                    </button>)
                                }

                            </div>

                            {message && (
                                <div className="alert-message">
                                    <p className={messageClass}> {message} </p>
                                </div>
                            )}


                        </div>
                    </div>
                </div>

                <div className="help-text">
                    <div>چرا از چنگال رژیم بگیریم؟</div>
                    <ul>
                        {helps.map((help, helpIndex) => <li key={helpIndex}>
                            <img className="tick-icon" src={TicIcon} alt="tic"/>
                            {help}</li>)}
                    </ul>
                </div>

                <div className="form-footer"
                     style={{marginTop: '1rem', borderTop: '1px solid #222', borderTopStyle: 'dashed'}}>
                    <div className="form-footer-container">
                        <div className="price-container">
                            <div className="title tar">مبلغ قابل پرداخت</div>
                            <div className="amount" style={{marginTop: '0.5rem'}}>
                                {subscriptionPackageFinalPrice > 0 ? `${number_format(subscriptionPackageFinalPrice)} تومان` : '...'}
                            </div>
                            <div className="amount amount-text" style={{marginTop: '0.5rem'}}>
                                {subscriptionPackageFinalPrice > 0 ? `${subscriptionPackageFinalPriceText} تومان` : (subscriptionPackageFinalPrice == 0 ? subscriptionPackageFinalPriceText : '...')}
                            </div>
                        </div>
                        <div className="save-button-container" style={{marginTop: '1rem'}}>
                            <Button appearance={isLoading ? 'default' : 'primary'}
                                    loading={isLoading}
                                    onClick={save}
                                    block>
                                <b style={{color: '#fff'}}>{submitButtonText}</b>
                            </Button>
                        </div>
                    </div>
                </div>
            </Form>
        </>);
    }

    function priceFormat(value) {
        return number_format(value);
    }

    function number_format(number, decimals, dec_point, thousands_sep) {
        // Strip all characters but numerical ones.
        number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
        var n = !isFinite(+number) ? 0 : +number,
            prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
            sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
            dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
            s = '',
            toFixedFix = function (n, prec) {
                var k = Math.pow(10, prec);
                return '' + Math.ceil(n * k) / k;
            };
        // Fix for IE parseFloat(0.55).toFixed(0) = 0;
        s = (prec ? toFixedFix(n, prec) : '' + Math.ceil(n)).split('.');
        if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
        }
        if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
        }
        return s.join(dec);
    }

    function getFormData() {
        if (formData || isLoading) {
            return formData;
        }

        const config = {
            headers: {Authorization: `Bearer ${AuthService.getAccessToken()}`}
        };

        const body = {};

        setIsLoading(true);

        axios.post(`${APP_URL}/api/subscription-packages`, body, config)
            .then(function (response) {
                setFormData(response.data.data);
                setHelps(response.data.helps);

                let lastSubscriptionPackageIndex = 0;

                const lastTransactionAmount = response.data.last_transaction_amount;

                if (lastTransactionAmount && lastTransactionAmount) {
                    lastSubscriptionPackageIndex = response.data.data.findIndex(item => item.final_price == lastTransactionAmount);
                }

                handleOnChangeSubscriptionPackage(response.data.data[lastSubscriptionPackageIndex]);
                setIsLoading(false);
            })
            .catch(function (error) {
                setIsLoading(false);

                if (!error.response) {
                    handleNotfound();
                    // toast.error('خطایی رخ داده است!', {
                    //     position: "top-right",
                    //     autoClose: 5000,
                    //     hideProgressBar: false,
                    //     closeOnClick: true,
                    //     pauseOnHover: true,
                    //     draggable: true,
                    //     progress: undefined,
                    //     theme: "light",
                    // });

                    return false;
                }

                const statusCode = error.response.status;
                switch (statusCode) {
                    case 422:
                        const {errors} = error.response.data;

                        for (const errorsKey in errors) {
                            const error = errors[errorsKey][0];

                            toast.error(error, {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
                        }
                        break;

                    case 401:
                        navigate('/auth')
                        break;
                    default:
                        handleNotfound();
                        // toast.error('خطایی رخ داده است!', {
                        //     position: "top-right",
                        //     autoClose: 5000,
                        //     hideProgressBar: false,
                        //     closeOnClick: true,
                        //     pauseOnHover: true,
                        //     draggable: true,
                        //     progress: undefined,
                        //     theme: "light",
                        // });
                        break;
                }
            });
    }

    function save() {
        if (isLoading) {
            return false;
        }

        if (!selectedSubscriptionPackage || selectedSubscriptionPackage < 0) {
            toast.error('لطفا برنامه مورد نظر خود را انتخاب نمایید!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            return false;
        }

        const config = {
            headers: {Authorization: `Bearer ${AuthService.getAccessToken()}`}
        };


        let body = {
            subscription_package_id: selectedSubscriptionPackage.id,
            voucher_code: code,
            source: 2,
             program: searchParams.get('program'),
            intend_url: window.location.protocol + "//" + window.location.host + '/subscriptions',
            failed_intend_url: window.location.protocol + "//" + window.location.host + '/dashboard',
        };

        const campaignParameters = CampaignService.get();

        body = {...body, ...campaignParameters}

        setIsLoading(true);

        axios.post(`${APP_URL}/api/gateway-transactions`, body, config)
            .then(function (response) {
                if (response.data.message) {
                    toast.loading(response.data.message, {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });
                }

                if (response.data.status && response.data.action) {
                    switch (response.data.action) {
                        case 'intent':
                            setTimeout(() => {
                                window.location.replace(response.data.data);
                            }, 2000);
                            break;
                    }
                } else {
                    setIsLoading(false);
                }
            })
            .catch(function (error) {
                setIsLoading(false);

                if (!error.response) {
                    // handleNotfound();
                    toast.error('خطایی رخ داده است!', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });

                    return false;
                }

                const statusCode = error.response.status;
                switch (statusCode) {
                    case 422:
                        const {errors} = error.response.data;

                        for (const errorsKey in errors) {
                            const error = errors[errorsKey][0];

                            toast.error(error, {
                                position: "top-right",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                                theme: "light",
                            });
                        }
                        break;

                    case 401:
                        navigate('/auth')
                        break;
                    default:
                        handleNotfound();
                        // toast.error('خطایی رخ داده است!', {
                        //     position: "top-right",
                        //     autoClose: 5000,
                        //     hideProgressBar: false,
                        //     closeOnClick: true,
                        //     pauseOnHover: true,
                        //     draggable: true,
                        //     progress: undefined,
                        //     theme: "light",
                        // });
                        break;
                }
            });
    }

    function handleNotfound() {
        return false;
        localStorage.setItem("error", 'PageNotFound');
        setIsLoading(false);
        //setStep('notfound');
        window.location.href = '';
    }

    function applyVoucher(subscriptionPackage) {
        if (!code || code.length < 2) {
            return false;
        }

        if (isLoading && isCheckingVoucher) {
            return false;
        }

        if (!subscriptionPackage || subscriptionPackage < 0) {
            toast.error('لطفا برنامه مورد نظر خود را انتخاب نمایید!', {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });

            return false;
        }

        setButtonStatus(false);
        setIsCheckingVoucher(true);
        setIsLoading(true);

        const config = {
            headers: {Authorization: `Bearer ${AuthService.getAccessToken()}`}
        };


        let body = {
            code: code,
            source: 2,
        };

        body = {...body}

        axios.post(`${APP_URL}/api/vouchers/check/` + subscriptionPackage.id, body, config)
            .then(function (response) {
                setVoucherAccept(false);
                if (response.data.message) {
                    setMessageClass('success');
                    setMessage(response.data.message);
                    setMessageType("code-group-success");
                    setButtonContent("حذف");
                    setVoucherAccept(true);
                    setSubscriptionPackageFinalPrice(response.data.data.final_price);
                    setSubscriptionPackageFinalPriceText(response.data.data.final_price_text);
                } else {
                    setSubscriptionPackageFinalPrice(subscriptionPackage.final_price);
                    setSubscriptionPackageFinalPriceText(subscriptionPackage.final_price_text);
                }

                if (response.data.data && response.data.data.trial_days && response.data.data.trial_days > 0) {
                    setTrialDays(response.data.data.trial_days);
                } else {
                    setTrialDays(null);
                }

                setIsCheckingVoucher(false);
                setIsLoading(false);
            })
            .catch(function (error) {
                setIsLoading(false);
                setIsCheckingVoucher(false);
                setVoucherAccept(false);
                if (!error.response) {
                    toast.error('خطایی رخ داده است!', {
                        position: "top-right",
                        autoClose: 5000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        theme: "light",
                    });

                    return false;
                }

                const statusCode = error.response.status;
                switch (statusCode) {
                    case 422:
                        setMessageClass('error');
                        setMessage(error.response.data.errors.code);
                        setMessageType("code-group-error");
                        setButtonContent("close");
                        break;

                    case 400:
                        setMessageClass('error');
                        setMessage(error.response.data.message);
                        setMessageType("code-group-error");
                        setButtonContent("close");
                        break;

                    case 401:
                        navigate('/auth')
                        break;
                    default:
                        // handleNotfound();
                        // toast.error('خطایی رخ داده است!', {
                        //     position: "top-right",
                        //     autoClose: 5000,
                        //     hideProgressBar: false,
                        //     closeOnClick: true,
                        //     pauseOnHover: true,
                        //     draggable: true,
                        //     progress: undefined,
                        //     theme: "light",
                        // });
                        break;
                }
            });
    }
}

export default SubscriptionPackage;